import {
  Box,
  Button,
  Collapse,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  useBreakpointValue,
  useDisclosure,
} from "@chakra-ui/react";
import LogoBtn from "components/LogoBtn";
import EditIcon from "images/icons/EditIcon";
import SearchIcon from "images/icons/SearchIcon";
import toastErrorAndReport from "lib/toastErrorAndReport";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";
import SwitchIcon from "../../images/icons/SwitchIcon";
import * as ga from "../../lib/analytics";
import { useWindowDimensions } from "../../lib/windows";
import appStore from "../../store";
import TimeSelectorContent from "./TimeSelectorContent";
import AddressInputContent from "./AddressInputContent";
import { sendAppierEvent } from "../../lib/appier";
import { getCityRegion } from "../../lib/delivery";
import axios from "axios";
import GCPImage from "components/GCPImage";
import { isAfter } from "date-fns";

const search = (t, onClose, setCenter) => {
  const {
    tempSelectedCity,
    tempSelectedZone,
    tempSelectedStation,
    tempSelectedZoneId,
    tempSelectedReturnCity,
    tempSelectedReturnZone,
    tempSelectedReturnStation,
    tempSelectedReturnZoneId,
    tempSelectedDays,
    tempSelectedStartClock,
    tempSelectedEndClock,
    isAirport,
    isAirportReturn,
    isSameAddress,
  } = appStore;

  if (isAirport === 0) {
    if (tempSelectedCity === "") {
      toastErrorAndReport(
        `${t("choose")}${t("city")}`,
        "HomeTimeSearchBar/search/pickup"
      );
      return;
    }
    if (tempSelectedZone === "") {
      toastErrorAndReport(
        `${t("choose")}${t("zone")}/${t("address")}`,
        "HomeTimeSearchBar/search/pickup"
      );
      return;
    }
  }

  if (tempSelectedDays.length !== 2) {
    toastErrorAndReport(
      `${t("choose")}${t("date")}`,
      "HomeTimeSearchBar/search/date"
    );
    return;
  }

  if (
    tempSelectedDays[0].format("YYYY/MM/DD") ===
    tempSelectedDays[1].format("YYYY/MM/DD")
  ) {
    toastErrorAndReport(`${t("timeError")}`, "HomeTimeSearchBar/search/date");
    return;
  }

  let queryString = "";

  if (isAirport === 0) {
    appStore.selectedCity = tempSelectedCity;
    appStore.selectedZone = tempSelectedZone;
    queryString = `${tempSelectedCity}${tempSelectedZone}`;
  } else if (isAirport === 1) {
    appStore.selectedCity = "桃園市";
    appStore.selectedZone = "大園區";
    appStore.selectedStation = "機場第一航廈";
    appStore.selectedZoneId = 2;
    queryString = `桃園市大園區機場第一航廈`;
  } else if (isAirport === 2) {
    appStore.selectedCity = "桃園市";
    appStore.selectedZone = "大園區";
    appStore.selectedStation = "機場第二航廈";
    appStore.selectedZoneId = 3;
    queryString = `桃園市大園區機場第二航廈`;
  }
  if (isAirportReturn === 0) {
    appStore.selectedReturnCity = tempSelectedReturnCity;
    appStore.selectedReturnZone = tempSelectedReturnZone;
    appStore.selectedReturnStation = tempSelectedReturnStation;
    appStore.selectedReturnZoneId = tempSelectedReturnZoneId;
  } else if (isAirportReturn === 1) {
    appStore.selectedReturnCity = "桃園市";
    appStore.selectedReturnZone = "大園區";
    appStore.selectedReturnStation = "機場第一航廈";
    appStore.selectedReturnZoneId = 2;
  } else if (isAirportReturn === 2) {
    appStore.selectedReturnCity = "桃園市";
    appStore.selectedReturnZone = "大園區";
    appStore.selectedReturnStation = "機場第二航廈";
    appStore.selectedReturnZoneId = 3;
  }

  axios.get(`/api/google_map_api_search?input=${queryString}`).then((res) => {
    axios
      .get(
        `/api/google_map_api_get_geo?placeId=${res.data.data.predictions[0].place_id}`
      )
      .then((res) => {
        setCenter(res.data.data.result.geometry.location);
      });
  });

  appStore.selectedDays = tempSelectedDays;
  // appStore.selectedStartClock = tempSelectedStartClock;
  // appStore.selectedEndClock = tempSelectedEndClock;

  onClose();

  fbq("track", "Search");
  ga.event({
    action: "search",
  });
  const searched_type =
    window?.location?.pathname === "/station" ? "同站租還" : "外送到府";
  const searched_city = appStore.selectedCity;
  const searched_zone = appStore.selectedZone;
  const searched_station = appStore.selectedStation;
  const searched_city_region = getCityRegion(searched_city);
  sendAppierEvent("searched", {
    searched_type,
    searched_location: `${searched_city}${searched_zone}`,
    searched_city,
    searched_zone,
    searched_city_region,
    searched_station,
  });

  return;
};

const MobileBar = ({ display, cityUnion, setCenter, calendarImgPath }) => {
  const { t } = useTranslation("common");
  const {
    selectedCity,
    selectedZone,
    selectedStation,
    selectedDays,
    selectedStartClock,
    selectedEndClock,
    isSameAddress,
  } = appStore;

  const router = useRouter();

  const {
    isOpen: isAddressTimeDrawerOpen,
    onOpen: onAddressTimeDrawerOpen,
    onClose: onAddressTimeDrawerClose,
  } = useDisclosure();

  const {
    isOpen: isTimeSelectorDrawerOpen,
    onOpen: onTimeSelectorDrawerOpne,
    onClose: onTimeSelectorDrawerClose,
  } = useDisclosure();

  const [isAddressCollapseOpen, setIsAddressCollapseOpen] = useState(true);

  const onAddressCollapseOpen = () => {
    setIsAddressCollapseOpen(true);
  };

  const onAddressCollapseClose = () => {
    setIsAddressCollapseOpen(false);
  };

  // const {
  //   isOpen: isAddressCollapseOpen,
  //   onOpen: onAddressCollapseOpen,
  //   onClose: onAddressCollapseClose,
  // } = useDisclosure();

  const {
    isOpen: isReturnAddressCollapseOpen,
    onOpen: onReturnAddressCollapseOpen,
    onClose: onReturnAddressCollapseClose,
  } = useDisclosure();

  const {
    isOpen: isTimeSelectorCollapseOpen,
    onOpen: onTimeSelectorCollapseOpen,
    onClose: onTimeSelectorCollapseClose,
  } = useDisclosure();

  const closeAndSearch = () => {
    const onClose = () => {
      onTimeSelectorDrawerClose();
      onAddressTimeDrawerClose();
    };
    search(t, onClose, setCenter);
  };

  const openMobileDrawer = () => {
    appStore.tempSelectedZoneId = null;
    onAddressTimeDrawerOpen();
  };

  return (
    <Flex
      pl="16px"
      pr="8px"
      py="8px"
      my="8px"
      display={display}
      bg="#F3F4F9"
      borderRadius="8px"
      alignItems="center"
      justify="space-between"
      border="1px solid #3374F6"
    >
      <Drawer
        autoFocus={false}
        size="full"
        isOpen={isAddressTimeDrawerOpen}
        placement="right"
        onClose={onAddressTimeDrawerClose}
      >
        <DrawerOverlay />
        <DrawerContent maxW="400px">
          <DrawerCloseButton size="lg" />
          <DrawerHeader>
            <LogoBtn isDisabled={true} />
            <Divider mt="16px" />
          </DrawerHeader>
          <DrawerBody>
            {isAddressCollapseOpen === false && (
              <Box
                p="16px"
                border="1px solid rgba(0, 0, 0, 0.1)"
                shadow="0px 2px 4px 2px rgba(0, 0, 0, 0.08)"
                borderRadius="8px"
                cursor="pointer"
                onClick={() => {
                  if (isTimeSelectorCollapseOpen) {
                    onTimeSelectorCollapseClose();
                  }
                  if (isReturnAddressCollapseOpen) {
                    onReturnAddressCollapseClose();
                  }
                  onAddressCollapseOpen();
                }}
              >
                <Text
                  fontSize="16px"
                  fontWeight="500"
                  lineHeight="23px"
                  color="rgba(170, 170, 170, 1)"
                  mb="8px"
                >
                  {t("pickupAddress")}
                </Text>
                {selectedCity !== "" ? (
                  <Text
                    textAlign="start"
                    fontSize="16px"
                    fontWeight="500"
                    lineHeight="23px"
                    color="rgba(51, 51, 51, 1)"
                  >
                    {t(`city_i18n.${selectedCity}`, {
                      defaultValue: selectedCity,
                    })}
                    {selectedZone !== "" &&
                      selectedZone !== null &&
                      `,${t(`zone_i18n.${selectedZone}`, {
                        defaultValue: selectedZone,
                      })}`}
                    {selectedStation !== "" &&
                      selectedStation !== null &&
                      selectedStation !== "chargeZone" &&
                      `,${t(`station_i18n.${selectedStation}`, {
                        defaultValue: selectedStation,
                      })}`}
                  </Text>
                ) : (
                  <Text
                    textAlign="start"
                    fontSize="16px"
                    fontWeight="500"
                    lineHeight="23px"
                    color="rgba(51, 51, 51, 1)"
                  >
                    {t("choose")}
                    {t("address")}
                  </Text>
                )}
                {isSameAddress && (
                  <Text
                    mt="8px"
                    fontSize="16px"
                    fontWeight="500"
                    lineHeight="24px"
                    color="#3374F6"
                  >
                    {t("Station_dropoff_sameLocation")}
                  </Text>
                )}
              </Box>
            )}
            <Collapse in={isAddressCollapseOpen} animateOpacity>
              <Box
                border="1px solid rgba(0, 0, 0, 0.1)"
                shadow="0px 8px 16px 8px rgba(0, 0, 0, 0.08)"
                borderRadius="8px"
                p="16px"
              >
                <Text
                  fontSize="24px"
                  fontWeight="700"
                  color="#333333"
                  lineHeight="35px"
                  mb="16px"
                >
                  {t("wherePickup")}
                </Text>
                <AddressInputContent cityUnion={cityUnion} />
              </Box>
            </Collapse>

            {isTimeSelectorCollapseOpen === false && (
              <Box
                mt="24px"
                p="16px"
                border="1px solid rgba(0, 0, 0, 0.1)"
                shadow="0px 2px 4px 2px rgba(0, 0, 0, 0.08)"
                borderRadius="8px"
                cursor="pointer"
                onClick={() => {
                  if (isAddressCollapseOpen) {
                    onAddressCollapseClose();
                  }
                  if (isReturnAddressCollapseOpen) {
                    onReturnAddressCollapseClose();
                  }
                  onTimeSelectorCollapseOpen();
                }}
              >
                <Text
                  fontSize="16px"
                  fontWeight="500"
                  lineHeight="23px"
                  color="rgba(170, 170, 170, 1)"
                  mb="8px"
                >
                  {t("useCarTimeTitle")}
                </Text>
                {selectedDays.length === 2 ? (
                  <Flex align="center">
                    <Text
                      fontFamily="Poppins, sans-serif"
                      fontSize="12px"
                      fontWeight="500"
                      lineHeight="17px"
                      color="rgba(51, 51, 51, 1)"
                    >
                      {selectedDays[0]?.format("MM/DD")}
                    </Text>
                    <SwitchIcon
                      mx="8px"
                      size="24px"
                      color="rgba(51, 51, 51, 1)"
                    />
                    <Text
                      fontFamily="Poppins, sans-serif"
                      fontSize="12px"
                      fontWeight="500"
                      lineHeight="17px"
                      color="rgba(51, 51, 51, 1)"
                    >
                      {selectedDays[1]?.format("MM/DD")}
                    </Text>
                  </Flex>
                ) : (
                  <Text
                    fontSize="16px"
                    fontWeight="500"
                    lineHeight="17px"
                    color="rgba(51, 51, 51, 1)"
                  >
                    {t("useCarTime")}
                  </Text>
                )}
              </Box>
            )}
            <Collapse in={isTimeSelectorCollapseOpen} animateOpacity>
              <Box
                mt="24px"
                border="1px solid rgba(0, 0, 0, 0.1)"
                shadow="0px 8px 16px 8px rgba(0, 0, 0, 0.08)"
                borderRadius="8px"
                p="16px"
              >
                <Text
                  fontSize="24px"
                  fontWeight="700"
                  color="#333333"
                  lineHeight="35px"
                  mb="16px"
                >
                  {t("stationWantUseCarTime")}
                </Text>
                <Box cursor="pointer" onClick={onTimeSelectorDrawerOpne}>
                  <Text fontSize="16px" fontWeight="500" lineHeight="23px">
                    {t("from")}
                  </Text>
                  <Flex
                    mt="8px"
                    mb="16px"
                    px="16px"
                    py="8px"
                    border="1px solid rgba(0, 0, 0, 0.1)"
                    borderRadius="8px"
                  >
                    {selectedDays[0] ? (
                      <Text
                        fontFamily="Poppins, sans-serif"
                        color="rgba(51, 51, 51, 1)"
                        fontSize="16px"
                        fontWeight="700"
                        lineHeight="23px"
                      >
                        {selectedDays[0]?.format("MM/DD")}
                      </Text>
                    ) : (
                      <Text
                        color="rgba(170, 170, 170, 1)"
                        fontSize="16px"
                        fontWeight="700"
                        lineHeight="23px"
                      >
                        {t("choose")}
                      </Text>
                    )}
                  </Flex>
                  <Text fontSize="16px" fontWeight="500" lineHeight="23px">
                    {t("to")}
                  </Text>
                  <Flex
                    mt="8px"
                    mb="16px"
                    px="16px"
                    py="8px"
                    border="1px solid rgba(0, 0, 0, 0.1)"
                    borderRadius="8px"
                  >
                    {selectedDays[1] ? (
                      <Text
                        fontFamily="Poppins, sans-serif"
                        color="rgba(51, 51, 51, 1)"
                        fontSize="16px"
                        fontWeight="700"
                        lineHeight="23px"
                      >
                        {selectedDays[1]?.format("MM/DD")}
                      </Text>
                    ) : (
                      <Text
                        color="rgba(170, 170, 170, 1)"
                        fontSize="16px"
                        fontWeight="700"
                        lineHeight="23px"
                      >
                        {t("choose")}
                      </Text>
                    )}
                  </Flex>
                </Box>
              </Box>
            </Collapse>
            <Flex mb="100px">
              <Button
                color="white"
                bg="rgba(51, 116, 246, 1)"
                mt="24px"
                flex={1}
                leftIcon={<SearchIcon size="24px" />}
                onClick={closeAndSearch}
              >
                {t("search")}
              </Button>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <Drawer
        autoFocus={false}
        size="full"
        isOpen={isTimeSelectorDrawerOpen}
        placement="right"
        onClose={onTimeSelectorDrawerClose}
      >
        <DrawerOverlay />
        <DrawerContent overflow="scroll">
          <DrawerCloseButton size="lg" />
          <DrawerHeader>{t("date")}</DrawerHeader>
          <DrawerBody>
            <TimeSelectorContent />

            {/* {calendarImgPath !== "" && (
              <Box
                mt="16px"
                w="100%"
                cursor="pointer"
                onClick={() => {
                  router.push({
                    pathname: "/newYear",
                    query: router.query,
                  });
                }}
              >
                <GCPImage
                  src={`${calendarImgPath}?v=${new Date().getTime()}`}
                  alt="timeSelect"
                />
              </Box>
            )} */}
            <Flex mb="100px" mt="24px">
              <Button
                flex="1"
                color="white"
                bg="rgba(51, 116, 246, 1)"
                onClick={closeAndSearch}
                leftIcon={<SearchIcon size="24px" />}
              >
                {t("search")}
              </Button>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <Box cursor="pointer" w="100%" onClick={openMobileDrawer}>
        <Flex align="center">
          {selectedDays.length === 2 &&
          selectedStartClock !== "" &&
          selectedEndClock !== "" ? (
            <>
              <Text
                fontFamily="Poppins, sans-serif"
                fontSize="16px"
                fontWeight="700"
                lineHeight="24px"
                color="#333333"
              >
                {selectedDays[0]?.format("MM/DD")}
                {" - "}
              </Text>
              <Text
                fontFamily="Poppins, sans-serif"
                fontSize="16px"
                fontWeight="700"
                lineHeight="24px"
                color="#333333"
              >
                {selectedDays[1]?.format("MM/DD")}
              </Text>
            </>
          ) : (
            <Text
              fontSize="12px"
              fontWeight="400"
              lineHeight="16px"
              color="#748598"
            >
              {t("whenPickup")}
            </Text>
          )}
        </Flex>
        <Flex>
          <Text
            mr="8px"
            fontSize="14px"
            fontWeight="400"
            lineHeight="20px"
            color="#0067D8"
          >
            {t("Station_label")}
          </Text>

          <Text
            fontSize="14px"
            fontWeight="400"
            lineHeight="20px"
            color="#748598"
          >
            {t(`city_i18n.${selectedCity}`, {
              defaultValue: selectedCity,
            }) +
              "," +
              t(`zone_i18n.${selectedZone}`, {
                defaultValue: selectedZone,
              })}
          </Text>
        </Flex>
      </Box>

      <Flex
        p="12px"
        bg="#3374F6"
        align="center"
        justify="center"
        borderRadius="8px"
        cursor="pointer"
        onClick={openMobileDrawer}
      >
        <EditIcon w="24px" h="24px" />
      </Flex>
    </Flex>
  );
};

const AddressTimeSearchBar = ({ cityUnion, setCenter }) => {
  const { t } = useTranslation("common");
  const { locale } = useRouter();
  const {
    selectedCity,
    selectedZone,
    selectedStation,
    selectedReturnCity,
    selectedReturnZone,
    selectedReturnStation,
    selectedDays,
    selectedStartClock,
    tempSelectedCity,
    tempSelectedZone,
    tempSelectedStation,
    tempSelectedZoneId,
    selectedEndClock,
    latestOrderTimeUnion,
    isAirport,
    isAirportReturn,
    isOpenCitySelect,
    isOpenReturnCitySelect,
    isSameAddress,
    tempSelectedReturnCity,
    tempSelectedReturnZone,
    tempSelectedReturnStation,
    tempSelectedReturnZoneId,
    isLoading,
  } = appStore;
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);

  const {
    isOpen: isFilterOpen,
    onOpen: onFilterOpen,
    onClose: onFilterClose,
  } = useDisclosure();

  const goNext = () => {
    if (!isSameAddress) {
      appStore.isOpenCitySelect = false;
      appStore.isOpenReturnCitySelect = true;
    } else {
      if (isAirport === 0) {
        if (tempSelectedCity === "") {
          toastErrorAndReport(
            `${t("choose")}${t("city")}`,
            "HomeTimeSearchBar/goNext/city"
          );
          return;
        }
        if (tempSelectedZone === "") {
          toastErrorAndReport(
            `${t("choose")}${t("zone")}/${t("address")}`,
            "HomeTimeSearchBar/goNext/zone"
          );
          return;
        }
      }
      appStore.isOpenCitySelect = false;

      setIsOpen(true);
    }
  };

  const closeAndSearch = () => {
    const onClose = () => {
      setIsOpen(false);
      appStore.isOpenCitySelect = false;
    };
    search(t, onClose, setCenter);
  };

  // console.log("tempSelectedZoneId", tempSelectedZoneId);
  // console.log("tempSelectedReturnZoneId", tempSelectedReturnZoneId);
  // console.log("selectedDays", selectedDays);
  // console.log("selectedStartClock", selectedStartClock);
  // console.log("selectedEndClock", selectedEndClock);

  useEffect(() => {
    if (isSameAddress) {
      appStore.tempSelectedReturnCity = tempSelectedCity;
      appStore.tempSelectedReturnZone = tempSelectedZone;
      appStore.tempSelectedReturnStation = tempSelectedStation;
      appStore.tempSelectedReturnZoneId = tempSelectedZoneId;
      appStore.isAirportReturn = isAirport;
    }
  }, [
    isAirport,
    isSameAddress,
    tempSelectedCity,
    tempSelectedStation,
    tempSelectedZone,
    tempSelectedZoneId,
  ]);

  useEffect(() => {
    if (
      tempSelectedCity !== tempSelectedReturnCity ||
      tempSelectedZone !== tempSelectedReturnZone ||
      tempSelectedStation !== tempSelectedReturnStation ||
      isAirport !== isAirportReturn
    ) {
      appStore.isSameAddress = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    tempSelectedReturnCity,
    tempSelectedReturnStation,
    tempSelectedReturnZone,
    isAirportReturn,
  ]);

  // HOTFIX:
  // 因為高度在 720 以下時，Popover 會被蓋住，所以要把他往上移
  const { height } = useWindowDimensions();

  const isHeightLessThan720 = useMemo(() => {
    if (height) {
      return height < 720;
    }
    return null;
  }, [height]);

  const isMdUp = useBreakpointValue({ base: false, md: true });
  const isTw = locale === "zh-TW";

  // const calendarImgPath = useMemo(() => {
  //   if (!router.isReady || isMdUp === undefined || isMdUp === null || isLoading)
  //     return "";

  //   const isAfter0116 = isAfter(new Date(), new Date("2025-01-16 00:00:00"));
  //   const isAfterNewYear = isAfter(new Date(), new Date("2025/02/02 23:59:59"));
  //   if (isAfterNewYear) {
  //     return "";
  //   }

  //   return isMdUp
  //     ? isTw
  //       ? `/images/lnyVersion/2025/calendarInfo_pc${isAfter0116 ? "_0116" : "_1225"}.png`
  //       : `/images/lnyVersion/2025/calendarInfoEN_pc${isAfter0116 ? "_0116" : "_1225"}.png`
  //     : isTw
  //       ? `/images/lnyVersion/2025/calendarInfo_mobile${isAfter0116 ? "_0116" : "_1225"}.png`
  //       : `/images/lnyVersion/2025/calendarInfoEN_mobile${isAfter0116 ? "_0116" : "_1225"}.png`;
  // }, [isMdUp, isLoading, router.isReady]);

  if (isHeightLessThan720 === null) return <></>;

  return (
    <>
      <MobileBar
        display={{ md: isHeightLessThan720 ? "flex" : "none", base: "flex" }}
        isFilterOpen={isFilterOpen}
        onFilterClose={onFilterClose}
        onFilterOpen={onFilterOpen}
        latestOrderTimeUnion={latestOrderTimeUnion}
        cityUnion={cityUnion}
        setCenter={setCenter}
        // calendarImgPath={calendarImgPath}
      />

      {/* Desktop */}
      <Box
        display={{ base: "none", md: isHeightLessThan720 ? "none" : "flex" }}
        my="20px"
        alignItems="center"
        justifyContent="center"
      >
        <Flex
          p="4px"
          border="1px solid rgba(0, 0, 0, 0.1)"
          borderRadius="8px"
          align="center"
          pos="relative"
        >
          <Popover
            isOpen={isOpenCitySelect}
            zIndex="998"
            placement="bottom-start"
            onClose={() => {
              appStore.isOpenCitySelect = false;
            }}
          >
            <PopoverTrigger>
              <Flex
                py="6px"
                px="8px"
                w="260px"
                cursor="pointer"
                alignItems="center"
                onClick={() => {
                  appStore.isOpenCitySelect = !isOpenCitySelect;
                }}
              >
                {selectedCity != "" && selectedZone != "" ? (
                  <>
                    <Text
                      w="60px"
                      whiteSpace={locale === "zh-TW" ? "nowrap" : "wrap"}
                      fontSize="14px"
                      fontWeight="400"
                      lineHeight="20px"
                      mr="8px"
                      color="#748598"
                    >
                      {t("Station_label")}
                    </Text>
                    <Text
                      w="180px"
                      textAlign="start"
                      fontSize="16px"
                      fontWeight="700"
                      lineHeight="24px"
                      color="#333333"
                      whiteSpace="nowrap"
                      textOverflow="ellipsis"
                      overflow="hidden"
                    >
                      {t(`city_i18n.${selectedCity}`, {
                        defaultValue: selectedCity,
                      })}
                      {selectedZone !== "" &&
                        selectedZone !== null &&
                        `,${t(`zone_i18n.${selectedZone}`, {
                          defaultValue: selectedZone,
                        })}`}
                    </Text>
                  </>
                ) : (
                  <Text
                    color="rgba(136, 136, 136, 1)"
                    fontSize="14px"
                    fontWeight="500"
                    lineHeight="20px"
                  >
                    {t("wherePickup")}
                  </Text>
                )}
              </Flex>
            </PopoverTrigger>
            <PopoverContent backgroundColor="white" flex="1" width="400px">
              <PopoverArrow />
              <PopoverBody p="24px">
                <AddressInputContent cityUnion={cityUnion} />
                <Divider />
                <Flex p="24px">
                  <Button
                    flex="1"
                    mx="5px"
                    variant="ghost"
                    onClick={() => {
                      appStore.tempSelectedCity = "";
                      appStore.tempSelectedZone = "";
                      appStore.tempSelectedStation = "";
                    }}
                  >
                    {t("clearAll")}
                  </Button>
                  <Button
                    flex="1"
                    mx="5px"
                    color="white"
                    bg="rgba(51, 116, 246, 1)"
                    onClick={goNext}
                  >
                    {isSameAddress
                      ? t("useCarTime")
                      : `${t("choose")}${t("dropoff_location")}`}
                  </Button>
                </Flex>
              </PopoverBody>
            </PopoverContent>
          </Popover>

          <Popover
            isOpen={isOpen}
            zIndex="99"
            placement="bottom"
            onClose={() => {
              setIsOpen(false);
            }}
          >
            <PopoverTrigger>
              <Box
                borderLeft="1px"
                borderColor="rgba(196, 196, 196, 1)"
                px="8px"
                maxW="300px"
                flex={1}
                display="flex"
                cursor="pointer"
                onClick={() => {
                  setIsOpen((state) => !state);
                }}
              >
                <Flex alignItems="center" flex={1} w="150px">
                  {selectedDays?.length === 2 && selectedStartClock != "" ? (
                    <Box>
                      <Text
                        fontSize="14px"
                        fontWeight="700"
                        lineHeight="20px"
                        fontFamily="Poppins, sans-serif"
                      >
                        {selectedDays[0].format("MM/DD")}
                      </Text>
                    </Box>
                  ) : (
                    <Text
                      fontSize="14px"
                      fontWeight="500"
                      lineHeight="20px"
                      color="rgba(136, 136, 136, 1)"
                    >
                      {t("pickupTime")}
                    </Text>
                  )}
                </Flex>
                <SwitchIcon size="24px" mr="8px" />
                <Flex alignItems="center" flex={1} w="150px">
                  {selectedDays?.length === 2 && selectedEndClock != "" ? (
                    <Box>
                      <Text
                        fontFamily="Poppins, sans-serif"
                        fontSize="14px"
                        fontWeight="700"
                        lineHeight="20px"
                        whiteSpace="nowrap"
                      >
                        {selectedDays[1].format("MM/DD")}
                      </Text>
                    </Box>
                  ) : (
                    <Text
                      fontSize="14px"
                      fontWeight="500"
                      lineHeight="20px"
                      color="rgba(136, 136, 136, 1)"
                    >
                      {t("returnTime")}
                    </Text>
                  )}
                </Flex>
              </Box>
            </PopoverTrigger>
            <PopoverContent
              backgroundColor="white"
              flex="1"
              width={{ md: "600px", base: "400px" }}
              overflow="scroll"
            >
              <PopoverArrow />
              <PopoverBody>
                <TimeSelectorContent />
                {/* {calendarImgPath !== "" && (
                  <Flex>
                    <Flex flex="1"></Flex>
                    <Flex
                      flex="1"
                      mt="16px"
                      w="100%"
                      cursor="pointer"
                      onClick={() => {
                        router.push({
                          pathname: "/newYear",
                          query: router.query,
                        });
                      }}
                    >
                      <GCPImage
                        src={`${calendarImgPath}?v=${new Date().getTime()}`}
                        alt="timeSelect"
                      />
                    </Flex>
                  </Flex>
                )} */}
                <Flex px="24px" mt="24px">
                  <Button
                    flex="1"
                    mr="16px"
                    mb="16px"
                    variant="ghost"
                    onClick={() => {
                      appStore.tempSelectedDays = [];
                      appStore.tempSelectedStartClock = "";
                      appStore.tempSelectedEndClock = "";
                    }}
                  >
                    {t("clean")}
                  </Button>
                  <Button
                    flex="1"
                    color="white"
                    bg="rgba(51, 116, 246, 1)"
                    onClick={closeAndSearch}
                    leftIcon={<SearchIcon size="24px" />}
                  >
                    {t("search")}
                  </Button>
                </Flex>
              </PopoverBody>
            </PopoverContent>
          </Popover>
          <Button
            size="sm"
            fontSize="14px"
            color="white"
            bg="rgba(51, 116, 246, 1)"
            onClick={closeAndSearch}
            leftIcon={<SearchIcon size="24px" />}
          >
            {t("search")}
          </Button>
        </Flex>
      </Box>
    </>
  );
};
export default AddressTimeSearchBar;
